import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Flex,
    Text,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '@salesforce/retail-react-app/app/components/link'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getPDPath} from '../../../utils/custom-utils'

export const LinkBanner = ({
    custom,
    textHeadline,
    changeTextColor,
    applyImageShade,
    category1,
    category2,
    category3,
    category4,
    category5,
    category6,
    category7,
    category8,
    category9,
    category10,
    category11,
    category12,
    customCategoryName1,
    customCategoryName2,
    customCategoryName3,
    customCategoryName4,
    customCategoryName5,
    customCategoryName6,
    customCategoryName7,
    customCategoryName8,
    customCategoryName9,
    customCategoryName10,
    customCategoryName11,
    customCategoryName12
}) => {
    const imageURL = custom?.image?.disBaseLink
    const {site, locale} = useMultiSite()

    // Build categories with dynamic URLs using getPDPath
    const categories = [
        {id: category1, name: customCategoryName1},
        {id: category2, name: customCategoryName2},
        {id: category3, name: customCategoryName3},
        {id: category4, name: customCategoryName4},
        {id: category5, name: customCategoryName5},
        {id: category6, name: customCategoryName6},
        {id: category7, name: customCategoryName7},
        {id: category8, name: customCategoryName8},
        {id: category9, name: customCategoryName9},
        {id: category10, name: customCategoryName10},
        {id: category11, name: customCategoryName11},
        {id: category12, name: customCategoryName12}
    ]
        .filter((cat) => cat.id && cat.name)
        .map((cat) => {
            const path = getPDPath(cat.id, site, locale)
            return {
                ...cat,
                url: path
            }
        })

    const styles = useMultiStyleConfig('containerStyles')
    const linkBannerStyles = useMultiStyleConfig('linkBanner')

    return (
        <Box className="link-banner" {...styles.containerStyles} test-data-id={'link-banner'}>
            <Box backgroundImage={`url(${imageURL})`} {...linkBannerStyles.linkBannerBlock}>
                {/* Background Shade */}
                {applyImageShade && <Box {...linkBannerStyles.linkBannerOverly} />}

                <Box {...linkBannerStyles.linkTestBlock}>
                    {/* Title */}
                    {textHeadline && (
                        <Text
                            as="h2"
                            color={changeTextColor ? 'white' : 'black'}
                            {...linkBannerStyles.linkBannerHeading}
                            dangerouslySetInnerHTML={{__html: textHeadline}}
                        />
                    )}

                    {/* Categories */}
                    <Flex {...linkBannerStyles.linkBannerLinkBlock}>
                        {categories.map((cat, index) => (
                            <Link
                                key={index}
                                to={cat.url}
                                color={changeTextColor ? 'white' : 'black'}
                                {...linkBannerStyles.linkBannerLink}
                                isExternal={cat.isExternal}
                            >
                                {cat.name}
                            </Link>
                        ))}
                    </Flex>
                </Box>
            </Box>
        </Box>
    )
}

LinkBanner.propTypes = {
    custom: PropTypes.object,
    textHeadline: PropTypes.string,
    changeTextColor: PropTypes.bool,
    applyImageShade: PropTypes.bool,
    category1: PropTypes.string,
    category2: PropTypes.string,
    category3: PropTypes.string,
    category4: PropTypes.string,
    category5: PropTypes.string,
    category6: PropTypes.string,
    category7: PropTypes.string,
    category8: PropTypes.string,
    category9: PropTypes.string,
    category10: PropTypes.string,
    category11: PropTypes.string,
    category12: PropTypes.string,
    customCategoryName1: PropTypes.string,
    customCategoryName2: PropTypes.string,
    customCategoryName3: PropTypes.string,
    customCategoryName4: PropTypes.string,
    customCategoryName5: PropTypes.string,
    customCategoryName6: PropTypes.string,
    customCategoryName7: PropTypes.string,
    customCategoryName8: PropTypes.string,
    customCategoryName9: PropTypes.string,
    customCategoryName10: PropTypes.string,
    customCategoryName11: PropTypes.string,
    customCategoryName12: PropTypes.string
}

export default LinkBanner
